export enum TripVehicleType {
  NotSet = -1,
  Above35Ton = 0,
  Below35Ton = 1,
  Bus = 2,
  Train = 3,
  Ferry = 4,
  Plane = 5,
  MiniBus = 6,
}
